import AuthLayoutPartial from "../../partials/auth/auth.layout";

export default function AuthLayoutScreen() {
  return <AuthLayoutPartial />;
}
